import React, { useState, useEffect } from 'react'
import { Form, Input } from 'antd';

const EventOrganiser = ({ data }) => {
  const [form] = Form.useForm();
  const [formLayout, setFormLayout] = useState('horizontal');

  const formItemLayout =
    formLayout === 'horizontal'
      ? {
        labelCol: {
          span: 4,
        },
        wrapperCol: {
          span: 14,
        },
      }
      : null;

      useEffect(() => {
        loadOrganiser() 
      }, [])
     
      const loadOrganiser = () => {

          form.setFieldsValue({
            organiserFirstname:data.organiserFirstname,
            organiserLastname:data.organiserLastname,
            organiserEmail:data.organiserEmail,
            years: data.years,
            details: data.details
          })
      }

  return (
    <>
      <Form
        {...formItemLayout}
        layout={formLayout}
        form={form}
        initialValues={{
          layout: formLayout,
        }}
        disabled

        // style={{
        //   maxWidth: 1000,
        // }}
      >
        <Form.Item
          label="First Name"
          name="organiserFirstname"
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Last Name"
          name="organiserLastname"
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Email Address"
          name="organiserEmail"
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Event details"
          name="details"
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Years of experience"
          name="years"
        >
          <Input />
        </Form.Item>
      </Form>
    </>
  )
}

export default EventOrganiser